// Pricing Group core
export function pricingGroupCore() {
  const endpoint = '/pricinggroups';
  const detailId = 'pricingGroupId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Pricing Group filter
export function pricingGroupFilter() {
  const parameter = 'PricingGroupId';

  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.pricingGroupId,
        label: row.pricingGroupDisplayName
      };
    });

    return rows;
  };

  return {
    parameter,
    getRows: getRows
  };
}
